export default "__VITE_ASSET__Bre9_dXE__"